(function(angular){
	"use strict";
	
	angular.module("skBrowserUtils", []);
	var module = angular.module("vms.formBackcompat", ["vms.formInputs"]);

	// Create a dummy empty mod namespace for back-compat, and list the modules to map.
	angular.module("skCheckboxAndRadio", []);
	var moduleAlias = {
		'skCheckBox' : {
			name: 'vmsCheckBox',
			module: "vms.formInputs"
		},
		'skRadioButton' : {
			name: 'vmsRadioButton',
			module: "vms.formInputs"
		},
		'skSwitch' : {
			name: 'vmsSwitch',
			module: "vms.formInputs"
		}
		
	};

	// Build up empty directive names.
	var k;
	for(k in moduleAlias){
		module.directive(k, [function() {
			return {};
		}]);
	}

	
	module.config(["$provide", function($provide) {
		var $ = angular.element;
		// Generate the alias
		var generateAliasModule = function(alias, directiveName, fromModule) {
			// Build empty backcompat directive names, these will get augmented by the config.
			var $injector = angular.injector(["ng", fromModule]);
			var directive = $injector.get(directiveName + "Directive");
			var newMod = $.extend({}, directive[0]);
			newMod.$$moduleName = "vms.formBackcompat";
			newMod.name = alias;
			newMod.require = alias;
			$provide.decorator(alias + "Directive", function() {
				return [newMod];
			});
		};
		
		var key, dirInfo;
		for(key in moduleAlias){
			dirInfo = moduleAlias[key];
			generateAliasModule(key, dirInfo.name, dirInfo.module);
		}
	}]);
})(window.angular);

